<template>
  <div>
    <!-- 单行量表 pc修改 21 -->
    <div>
      <el-radio-group class="matrix-nps-scale" v-model="getSingleScale(rowData).model" @input="updateNewData($event, rowData)">
        <el-radio
          class="single-scale-items"
          v-for="(item, id) of rowData.questionDetails.issue.labels"
          :key="id"
          :label="getNps(item, rowData)"
          >{{ item.text }}</el-radio
        >
      </el-radio-group>
    </div>
  </div>
</template>

<script>
import { itemInitOptions } from '../config/config.js'
import { getNps, updateNewData } from '../public/index.js'
import '../public/style.css'
import { saveArr } from '../public/index.js'

export default {
  name: 'SingleScale',
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 需要更新的 数组
    updateArr: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      aa: ''
    }
  },
  computed: {
    //rowData.items[0].value
    getSingleScale() {
      return function (row) {
        const items = row.items.length ? row.items : []
        if (items.length) {
          return {
            model: items[0].value
          }
        } else {
          row.items.push(Object.assign({}, itemInitOptions))
          return {
            model: row.items[0].value
          }
        }
      }
    }
  },
  methods: {
    getNps,
    updateNewData,
    saveArr
  }
}
</script>

<style lang="scss" scoped>
// NPS量表和矩阵量表的选项按钮不在一行
.matrix-nps-scale.el-radio-group {
  ::v-deep.el-radio__label {
    vertical-align: middle;
    white-space: normal;
    max-width: 200px;
    display: inline-block;
  }
}
.single-scale-items
  // 自定义量表Items样式
{
  margin: 5px 10px;
}
::v-deep.matrix-nps-scale .el-radio-group .el-radio__label {
  max-width: 70px !important;
}
</style>
